import { Command } from '@/app/common/base/command'

export interface TwoFactorAuthStatus {
    twoFactorEnabled: boolean
    twoFactorMethod: 'totp' | 'email'
    verifyRateLimited: boolean
    verifyLockoutSeconds: number
    emailRateLimited: boolean
    emailLockoutSeconds: number
    maskedEmail?: string
}

export class GetTwoFactorAuthStatusCommand extends Command {
    public async run(): Promise<TwoFactorAuthStatus> {
        const response = await this.client.get('/api/settings/two-factor-auth-status')
        const data = response.asObject() as Record<string, unknown>

        return {
            twoFactorEnabled: (data.two_factor_enabled as boolean) ?? false,
            twoFactorMethod: (data.two_factor_method as 'totp' | 'email') ?? 'totp',
            verifyRateLimited: (data.verify_rate_limited as boolean) ?? false,
            verifyLockoutSeconds: (data.verify_lockout_seconds as number) ?? 0,
            emailRateLimited: (data.email_rate_limited as boolean) ?? false,
            emailLockoutSeconds: (data.email_lockout_seconds as number) ?? 0,
            maskedEmail: (data.masked_email as string) ?? undefined
        }
    }
}
